import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { PatientPortalService } from '../../patient-portal/patient-portal.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user.service';
import { StaticDataService } from 'src/app/services/static-data.service';
import { TreatmentPlanningDataModel } from '../models/treatment-planning-data.model';
import { TreatmentPlanningProcedurePseudoModel } from '../models/treatment-planning-procedure-pseudo.model';
import { SignaturePad } from '@tdo-inc/tdox-signaturepad/dist/tdox-signaturepad';
import { BlobModel } from 'src/app/models/blob/blob.model';
import { Globals } from 'src/app/globals';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AzureBlobStorageService } from 'src/app/services/blob/azure-blob-storage.service';
import { DialogService } from 'src/app/services/dialog.service';
import { MessagingConstants } from 'src/app/models/MessagingConstants';
import { MessagingService } from 'src/app/services/messaging.service';

@Component({
  selector: 'app-treatment-plan-approval',
  templateUrl: './treatment-plan-approval.component.html',
  styleUrls: ['./treatment-plan-approval.component.scss']
})
export class TreatmentPlanApprovalComponent implements OnInit {
  @Input() treatmentPlanId: string;
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  @ViewChild('padContainer') formElement: ElementRef;


  isLoading: boolean = false;
  isSigned: boolean = false;
  patientId: string;
  treatment: TreatmentPlanningDataModel;
  signatureBase64: SafeUrl;
  signaturePadOptions: object = {
    minWidth: 2,
    canvasHeight: 100,
    canvasWidth: 700
  };

  constructor(
    public globals: Globals,
    private staticDataService: StaticDataService,
    private patientPortalService: PatientPortalService,
    private dialogService: DialogService,
    private sanitizer: DomSanitizer,
    private azureService: AzureBlobStorageService,
    private messagingService: MessagingService,
    private toastr: ToastrService
  ) {

    this.patientId = this.globals.currentPatientId;

  }

  async ngOnInit() {
    if (UserService.authToken && !this.staticDataService.isReady) {
      this.staticDataService.refreshValues();
    }

    var promises = [
      this.getTreatmentPlan()
    ];

    this.isLoading = true;

    Promise.all(promises).then((results: any[]) => {
      this.treatment = results[0];
      this.isLoading = false;

    }, err => {
      this.displayMessage("Error", "Something went wrong");
      this.isLoading = false;
    });
  }

  getTreatmentPlan() {
    let promise = new Promise((resolve, reject) => {
      this.patientPortalService.getPatientTreatmentPlan(this.patientId, this.treatmentPlanId)
        .subscribe(resolve, reject);
    });
    return promise;
  }
  displayMessage(type, message) {

    if (type.toLowerCase() === "error")
      this.toastr.error(message, null, { timeOut: 7000 });
    else
      this.toastr.success(message, null, { timeOut: 3000 });
  }


  getFee(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceAdjusted !== null && procedure.PriceAdjusted !== 0) {
      return procedure.PriceAdjusted.toFixed(2);
    } else {
      return '0.00';
    }
  }

  getTotalFee(){
    return this.treatment.Procedures.reduce((n, {PriceAdjusted}) => n + PriceAdjusted, 0).toFixed(2);
  }

  getInsuranceEstimate(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceTotalDueByInsurance != null && procedure.PriceTotalDueByInsurance !== 0) {
      return procedure.PriceTotalDueByInsurance.toFixed(2);
    } else {
      return '0.00';
    }
  }

  getTotalInsuranceEstimate(){
    return this.treatment.Procedures.reduce((n, {PriceTotalDueByInsurance}) => n + PriceTotalDueByInsurance, 0).toFixed(2);
  }

  getDeductible(procedure: TreatmentPlanningProcedurePseudoModel): string {
    // Currently deductible isn't being brought across
    if (procedure.Deductible != null) {
      return procedure.Deductible.toFixed(2);
    } else {
      return '0.00';
    }
  }

  getTotalDeductible(){
    return this.treatment.Procedures.reduce((n, {Deductible}) => n + Deductible, 0).toFixed(2);
  }

  getPaymentEstimate(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceDueByPatient !== null && procedure.PriceDueByPatient !== 0) {
      return procedure.PriceDueByPatient.toFixed(2);
    } else {
      return '0.00';
    }
  }

  getTotalPaymentEstimate(){
    return this.treatment.Procedures.reduce((n, {PriceDueByPatient}) => n + PriceDueByPatient, 0).toFixed(2);
  }

  ApproveTreatment() {
    this.dialogService.openConfirmDialog(`Do you want to approve Treatment Option <br/><b>${this.treatment.Description}</b>?`).subscribe((confirmSend) => {
      if (confirmSend) {
        this.isLoading = true;
        this.patientPortalService.sendPatientTreatmentPlanApproval(this.patientId, this.treatment.TreatmentPlanningID).subscribe(resp => {
          if (resp) {
            this.treatment.enumTreatmentPlanStatusID = '00000a32-1000-0000-0000-000000000004';
            this.messagingService.sendComponentMessage(MessagingConstants.PATIENT_TREATMENT_APPROVED, { treatmentPlanId: this.treatment.TreatmentPlanningID });
            this.isLoading = false;
          }
        },
          error => {
            this.displayMessage("Error", "Error sending approval for treatment.");
          }
        );
      }
    });
  }

  RejectTreatment() {
    this.dialogService.openConfirmDialog(`Do you want to reject Treatment Option <br/><b>${this.treatment.Description}</b>?`).subscribe((confirmSend) => {
      if (confirmSend) {
        console.log('TreatmentPlanningComponent sendPatientTreatmentPlanRejection call.');
        this.isLoading = true;
        this.patientPortalService.sendPatientTreatmentPlanRejection(this.patientId, this.treatment.TreatmentPlanningID).subscribe(resp => {
          console.log('TreatmentPlanningComponent sendPatientTreatmentPlanRejection response: ', resp);
          if (resp) {
            this.isLoading = false;
            console.log('TreatmentPlanningComponent sendPatientTreatmentPlanRejection success, sendComponentMessage.');
            this.treatment.enumTreatmentPlanStatusID = '00000a32-1000-0000-0000-000000000003';
            this.messagingService.sendComponentMessage(MessagingConstants.PATIENT_TREATMENT_REJECTED, { treatmentPlanId: this.treatment.TreatmentPlanningID });
          }
        },
          error => {
            this.isLoading = false;
            this.displayMessage("Error", "Error sending rejection for treatment.");
          }
        );
      }
    });
  }

  getSignature() {
    if (this.treatment?.TreatmentPlanningID) {
      this.azureService.downloadBlob(this.treatment.TreatmentPlanningID + '.jpg', (res) => {
        if (res) {
          const objectURL = URL.createObjectURL(res);
          this.signatureBase64 = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        } else {
          this.signatureBase64 = null;
          //this.resizeSignature();
        }
        this.resizeSignature();
      }, 'tdox/patient/' + this.patientId);
    }
  }

  onSignatureDrawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    const drawData = this.signaturePad.toDataURL();
    fetch(drawData)
      .then(res => res.blob())
      .then((tmp) => {
        const blobModel = new BlobModel();
        blobModel.name = this.treatment.TreatmentPlanningID + '.jpg';
        blobModel.content = tmp;
        blobModel.patientId = this.patientId;
        this.azureService.uploadBlobs([blobModel], (isSuccess) => {
          this.isSigned = true;
        });
      });
  }

  onSignatureDrawStart() { }

  resizeSignature() {
    const ivl = setInterval(() => {
      if (this.formElement?.nativeElement.offsetWidth === 0) {
        return;
      }
      if (!this.signaturePad) {
        return;
      }
      clearInterval(ivl);
      this.signaturePad.queryPad()._canvas.width = this.formElement?.nativeElement.offsetWidth;
      this.signaturePad.queryPad()._canvas.height = this.formElement?.nativeElement.offsetHeight;
    }, 3000);
  }

  resetSignature() {
    this.signaturePad.clear();
    this.isSigned = false;
  }

}
